import React from 'react';
import LayoutRoute from '@/components/Layout/LayoutRoute';
import { useCan } from '@/hooks/useRbac';
import { SelectCompany } from '@/modules/app/SelectCompany';
import { LayoutRouteProps } from './LayoutRoute';
import { SentryTracedRoute } from '@/modules/app/SentryRoute';
import {
  SelectedContextProvider,
  useSelectedFilterState,
} from '@/hooks/useFilter';
const ComingSoonPage = React.lazy(
  () => import('@/components/Layout/ComingSoon')
);

export type ContextRestrictedLayoutRouteProps = {
  hiddenPage?: boolean;
} & LayoutRouteProps;

export const ContextRestrictedLayoutRoute: React.FC<
  ContextRestrictedLayoutRouteProps
> = (props) => {
  const can = useCan();
  const canShowPage = !props.hiddenPage || can('debug:view');
  return (
    <>
      <SentryTracedRoute path={props.path} exact={props.exact}>
        <SelectCompany>
          <SelectedContextProvider>
            <ContextRestrictedLayoutRouteContent
              {...props}
              component={canShowPage ? props.component : ComingSoonPage}
            />
          </SelectedContextProvider>
        </SelectCompany>
      </SentryTracedRoute>
    </>
  );
};

const ContextRestrictedLayoutRouteContent: React.FC<
  ContextRestrictedLayoutRouteProps
> = (props) => {
  const filter = useSelectedFilterState();

  return (
    <LayoutRoute
      {...props}
      rbacCheckArgs={{
        ...props.rbacCheckArgs,
        filterQuery: filter.query,
      }}
    />
  );
};
